import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const About = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M7,24c0,-9.326 7.674,-17 17,-17c9.326,0 17,7.674 17,17c0,9.326 -7.674,17 -17,17c-0.003,0 -0.006,0 -0.009,0c-9.321,0 -16.991,-7.67 -16.991,-16.991c0,-0.003 0,-0.006 0,-0.009Zm2.656,0c0,7.869 6.475,14.344 14.344,14.344c7.869,0 14.344,-6.475 14.344,-14.344c0,-7.869 -6.475,-14.344 -14.344,-14.344c-0.003,0 -0.005,0 -0.008,0c-7.864,0 -14.336,6.472 -14.336,14.336c0,0.003 0,0.005 0,0.008Zm12.684,8.134c0,-0.91 0.749,-1.66 1.66,-1.66c0.911,0 1.66,0.75 1.66,1.66c0,0.911 -0.749,1.661 -1.66,1.661c-0.911,0 -1.66,-0.75 -1.66,-1.661Zm0.332,-3.984l0,-3.32c0,0 0,0 0,0c0,-0.729 0.6,-1.328 1.328,-1.328c1.457,0 2.656,-1.199 2.656,-2.656c0,-1.458 -1.199,-2.657 -2.656,-2.657c-1.457,0 -2.656,1.199 -2.656,2.657c0,0.728 -0.6,1.328 -1.328,1.328c-0.729,0 -1.328,-0.6 -1.328,-1.328c0,-2.915 2.398,-5.313 5.312,-5.313c2.914,0 5.313,2.399 5.313,5.313c0,2.415 -1.647,4.54 -3.985,5.144l0,2.161c-0.018,0.715 -0.612,1.294 -1.328,1.294c-0.717,0 -1.31,-0.579 -1.329,-1.294l0.001,-0.001Z" fill={fill} />
    </svg>
  );
};

About.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

About.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
